import { Box, Divider, useTheme } from '@mui/material'
import CustomTypography from 'components/Fileds/CustomTypography'
import React from 'react'
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const OrderHeader = ({ title, orderId, handleBack, textColor }) => {
    const theme = useTheme();
    return (
        <Box >
            {/* Back Arrow Icon & Screen Title */}
            <Box className='d-flex align-items-center' sx={{ gap: 2 }}>
                <Box className='back-rounded-icon d-flex align-items-center justify-content-center cursor-pointer'
                    onClick={handleBack}
                    sx={{ border: '1px solid #4D4D4D', borderRadius: '50%', width: '30px', height: '30px', backgroundColor: 'white' }}>
                    <ChevronLeftIcon />
                </Box>
                <Box className='d-flex align-items-center justify-content-center' sx={{ gap: 1 }}>
                    <CustomTypography
                        label={title}
                        variant={"h5"}
                        sx={{
                            fontSize: '22px', fontWeight: 700,
                            color: textColor ? textColor : theme.palette.drawermenuitem.main, mb: 0
                        }}
                    />
                    <Divider orientation="vertical" flexItem sx={{ borderColor: `#4D4D4D !important` }} />
                    <CustomTypography
                        label={`#${orderId}`}
                        variant={"h5"}
                        sx={{
                            fontSize: '22px', fontWeight: 500,
                            color: theme.palette.drawermenuitem.main, mb: 0
                        }}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default OrderHeader
